// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3GPAS","infoBtn":"quickbooks_infoBtn__2tygK","formBox":"quickbooks_formBox__12J8n","formFooter":"quickbooks_formFooter__1zsN0"};